import { clone, mergeDeepWith } from 'ramda';

import { ILiveGamesTable, TLiveGamesTableUpdate, ILiveGamesSubscription } from '../types';

export const mergeTables = (
    oldTables: ILiveGamesTable[] = [],
    newTables: ILiveGamesTable[] = []
): ILiveGamesTable[] => {
    const tables = [...newTables, ...oldTables];

    return tables.filter((value, index, self) =>
        self.findIndex(v => v.launchAlias === value.launchAlias) === index);
};

export const updateTables = (
    oldTables: ILiveGamesTable[] = [],
    newTables: TLiveGamesTableUpdate[] = []
) => {
    return oldTables.map((oldTable) => {
        const newTable = newTables.find((table) => table.launchAlias === oldTable.launchAlias);

        return newTable ? mergeDeepWith(clone, newTable, oldTable) : oldTable;
    });
};

export const removeTables = (
    oldTables: ILiveGamesTable[],
    tablesToRemove: string[],
    subscriptions?: ILiveGamesSubscription[]
): ILiveGamesTable[] => {
    let tableAliasesToRemove = [...tablesToRemove];

    if (subscriptions) {
        tableAliasesToRemove = tableAliasesToRemove.filter((aliasToRemove) => {
            let count = 0;

            subscriptions.forEach((subscription) => {
                if (subscription.tables.filter((table) => table.launchAlias === aliasToRemove).length) {
                    count++;
                }
            });

            return count <= 1;
        });
    }

    return oldTables.filter((table) => !tableAliasesToRemove.includes(table.launchAlias));
};

export const syncTablesWithSubscriptions = (
    oldTables: ILiveGamesTable[],
    subscriptions: ILiveGamesSubscription[]
): ILiveGamesTable[] => {
    return oldTables.reduce((acc, table) => {
        subscriptions.forEach((subscription) => {
            if (subscription.tables.find((subscriptionTable) => subscriptionTable.launchAlias === table.launchAlias)) {
                acc.push(table);
            }
        });

        return acc;
    }, [] as ILiveGamesTable[]);
};
